import { Dialog } from 'vant';
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },

    data() {
        return {
            memberId: '',
            exchangeList: [],
        };
    },
    mounted() {
        this.memberId = this.$route.query.memberId;
        console.log(this.memberId);
        this.getExchangeList();

    },
    methods: {
        // 列表接口
        getExchangeList() {
            this.$api.getExchangeList({
                params: {
                    memberId: this.memberId,
                },
                success: function(res) {
                    console.log("res", res);
                    this.exchangeList = res.data
                    console.log("exchangeList", this.exchangeList);
                }.bind(this)
            })
        },
        comfirm(recodeId) {
            Dialog.confirm({
                    title: '确认领取',
                    message: '如您已确认领取到物品后，请点击"确认"，如未领取请点击"取消"。\n' +
                        '(注意：请在工作人员指导下现场点击“确认”，完成核销。)',
                    theme: 'round-button',
                    confirmButtonText: '领取',
                    cancelButtonText: '取消',
                }).then(() => {
                    // on close
                    this.exchangeWriteOff(recodeId)

                })
                .catch(() => {
                    // console.log('// on cancel');
                });
        },
        // 用户自主核销
        exchangeWriteOff(recodeId) {
            this.$api.exchangeWriteOff({
                params: {
                    recodeId: recodeId,
                },
                success: function(res) {
                    console.log("WriteOffState", res);
                    if (res.code == 0) {
                        Dialog({
                            title: res.data,
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            location.reload();
                        });

                    }
                }
            })
        },
        // 点击领取地点弹框
        dialogAddress(val) {
            Dialog({
                title: '领取地点',
                message: '请前往指定地点领取',
                theme: 'round-button',
            }).then(() => {
                // on close
                // location.reload();
            });
        },
    }
};